import TimerComponent from './components/Timer/Timer.vue'

export {
 TimerComponent
};

const components = [
 TimerComponent
];

const install = function (Vue) {
 components.forEach((comp) => {
   Vue.component(comp.name, comp)
 })
}

export default install
